// import logo from './logo.svg';
import "./App.css";
import Timer from "./components/timer.tsx";

function App() {
  return (
    <div className="App">
      <div className="App-header">
        <Timer />
      </div>
    </div>
  );
}

export default App;
